module.exports = "void main(void){\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);\n}\n";
